

<div class="row">
  <div class="col-md-11 padding-right-0px">
    <button type="button"
            class="btn  actions-btn-prime float-right" (click)="AddEmergencyDetails()">
      Add New
    </button>
  </div>
</div>
<div class="row">
  <!--<div class="col-md-4 padding-l-0px">
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form padding-lr-0px">
      <div class="card-header wh-header2  padding-left-7px padding-top-6px margin-top-10">
        Family


      </div>
      <div class="card-body card-body-general padding-top-8px" *ngIf="SelectedPatientEmergencyDetails">
        <div class="row" >
          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
            <div class="row">
              <div class="col-md-4 padding-right-0px text-align-left">
                <label for="firstName">Full Name </label>
              </div>:
              <div class="col-md-5 text-align-right">


                <label>{{SelectedPatientEmergencyDetails.EmergencyContactPersonName}}</label>
              </div>

            </div>

          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
            <div class="row">
              <div class="col-md-4 padding-right-0px text-align-left">
                <label for="diaplayName"> Relationship</label>
              </div>:

              <div class="col-md-5 text-align-right">

                <label>{{SelectedPatientEmergencyDetails.RelationType}}</label>

              </div>
            </div>


          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
            <div class="row">
              <div class="col-md-4  text-align-center">
                <label for="diaplayName"> <i class="fas fa-mobile-alt font-size-color"></i> </label>
              </div>:
              <div class="col-md-5 text-align-right">

                <label>{{SelectedPatientEmergencyDetails.EmergencyContactNo1}}</label>
              </div>
            </div>


          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
            <div class="row">

              <div class="col-md-4 text-align-center ">
                <label for="email address"><i class="fas fa-envelope font-size-color"></i></label>
              </div>:
              <div class="col-md-5  text-align-right">

                <label>{{SelectedPatientEmergencyDetails.EmergencyContactNo1}}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-4 padding-l-0px">
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form padding-lr-0px">
      <div class="card-header wh-header2  padding-left-7px padding-top-6px margin-top-10">
        Hospital


      </div>
      <div class="card-body card-body-general padding-top-8px">
        <div class="row">
          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
            <div class="row">
              <div class="col-md-4 padding-right-0px text-align-left">
                <label for="firstName">Full Name </label>
              </div>:
              <div class="col-md-5 text-align-right">


                <label>{{SelectedPatientEmergencyDetails.PreferredHospital}}</label>
              </div>

            </div>

          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
            <div class="row">
              <div class="col-md-4 text-align-left padding-right-0px">
                <label for="diaplayName">Location </label>
              </div>:
              <div class="col-md-5 text-align-right">

                <label>{{SelectedPatientEmergencyDetails.City}}</label>
              </div>
            </div>


          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
            <div class="row">
              <div class="col-md-4  text-align-center">
                <label for="diaplayName"> <i class="fas fa-mobile-alt font-size-color"></i> </label>
              </div>:
              <div class="col-md-5  text-align-right">

                <label>+91-8106220988</label>
              </div>
            </div>


          </div>
        </div>

      </div>
    </div>
  </div>-->

  <div class="col-md-12">
    <div class="table-component">
      <div class="table-responsive overflow-x">


        <table class="table table-striped margin-left-zero"
               cols="auto,2*,*,*,*,*,*,*">

          <thead class="">
            <tr>

              <!--<th></th>-->
              <th class="">
                Relation Type
              </th>
              <th class="">
                Name
              </th>


              <th>
                Number
              </th>

              <th>City</th>

              <th></th>


            </tr>
          </thead>

          <tbody class="table-body">
            <tr *ngFor="let l of CurrentEmergencyContactInfoController">

              <!--<td></td>-->
              <td>{{l.RelationType}}</td>
              <!--<td *ngIf="l.RelationType=='Family / Relative'">{{l.EmergencyContactPersonName}}</td>-->
              <td>
                <label *ngIf="l.RelationType=='Family/Relative'">{{l.EmergencyContactPersonName}}</label>
                <label *ngIf="l.RelationType=='Preferred Hospital'">{{l.EmergencyContactPersonName}}</label>
              </td>
              <td>
                <label *ngIf="l.RelationType=='Family/Relative'">{{l.EmergencyContactNo1}}</label>
                <label *ngIf="l.RelationType=='Preferred Hospital'">{{l.EmergencyContactNo1}}</label>
              </td>
              <td>{{l.EmergencyAddress}}</td>
              <td>
                <a (click)="edit(l)" class="nav-link-hand education-navlink float-right date-color-contracts" title="Edit">
                  <span class="badge"><i class="fas fa-pencil-alt"></i></span>
                </a>
                <a (click)="del_()" class="nav-link-hand education-navlink float-right">
                  <span class="badge">
                    <i class="far fa-trash-alt font-size-15px"></i>
                  </span>
                </a>
              </td>
            </tr>

          </tbody>

        </table>
      </div>
    </div>
  </div>

</div>

<div class="row">

</div>



